interface ImageMentionItem {
  disabled?: boolean;
}

export function buildImageMentionOptions(items: ImageMentionItem[]) {
  return items.map((item, index) => ({
    label: `图片${index + 1}`,
    value: `图片${index + 1}`,
    disabled: item.disabled,
  }));
}
